import { uuid } from '@gilbarbara/helpers/lib';
import { createReducer } from '@reduxjs/toolkit';

import { grades, initialMessages, initialQuestions } from 'config';
import { STATUS } from 'literals';

import {
  login,
  loginSuccess,
  logOut,
  logOutSuccess,
  setCoach,
  setGrade,
  setListen,
  userAnswer,
  userAnswerSuccess,
  userSpeak,
  userSpeakFailure,
  userSpeakSuccess,
} from 'actions';

import { UserState } from 'types';

export const userState = {
  isAuthenticated: false,
  coach: 0,
  grade: 0,
  conversationId: '',
  questions: initialQuestions,
  messages: initialMessages,
  status: STATUS.IDLE,
  listen: false,
};

export default {
  user: createReducer<UserState>(userState, builder => {
    builder
      .addCase(login, (draft, { payload }) => {
        const { coach = 0, grade = 0, isContinue = false } = payload || {};

        draft.status = STATUS.RUNNING;
        draft.grade = grade;
        draft.coach = coach;

        if (!isContinue) {
          draft.conversationId = uuid();
          // if (grade === 0 && coach === 0) {
          draft.messages[grade][coach] = [
            {
              role: 'assistant',
              content: '',
            },
            {
              role: 'user',
              content: `${
                coach === 0
                  ? grades[grade].prompt
                  : grades[grade].prompt.replaceAll('BigBrogrammer', 'AuntiePrenneur')
              }`,
            },
          ];
          // } else {
          //   draft.messages[grade][coach] = [
          //     {
          //       role: 'system',
          //       content: `${coaches[coach].prompt}`,
          //     },
          //     {
          //       role: 'user',
          //       content: `${grades[grade].prompt}`,
          //     },
          //   ];
          // }

          draft.questions[grade][coach] = '';
        }
      })
      .addCase(loginSuccess, draft => {
        draft.isAuthenticated = true;
        draft.status = STATUS.READY;
      });

    builder
      .addCase(logOut, draft => {
        draft.status = STATUS.RUNNING;
      })
      .addCase(logOutSuccess, draft => {
        draft.isAuthenticated = false;
        draft.status = STATUS.IDLE;
      });

    builder
      .addCase(userAnswer, (draft, { payload }) => {
        if (draft.questions[draft.grade][draft.coach] && payload) {
          draft.messages[draft.grade][draft.coach].push(
            { role: 'assistant', content: draft.questions[draft.grade][draft.coach] },
            { role: 'user', content: payload },
          );
        }

        draft.status = STATUS.RUNNING;
      })
      .addCase(userAnswerSuccess, (draft, { meta, payload }) => {
        if (meta) {
          draft.questions[draft.grade][draft.coach] += payload;
        } else {
          draft.questions[draft.grade][draft.coach] = !payload ? '' : payload;
        }

        draft.status = STATUS.READY;
      });

    builder
      .addCase(setGrade, (draft, { payload }) => {
        draft.grade = payload;
      })
      .addCase(setCoach, (draft, { payload }) => {
        draft.coach = payload;
      })
      .addCase(setListen, (draft, { payload }) => {
        draft.listen = payload;
      });

    builder
      .addCase(userSpeak, draft => {
        draft.status = STATUS.IDLE;
      })
      .addCase(userSpeakSuccess, draft => {
        draft.status = STATUS.READY;
      })
      .addCase(userSpeakFailure, draft => {
        draft.status = STATUS.READY;
      });
  }),
};
